export default "__VITE_ASSET___pwT791c__"